<template>
  <div class="home">
    <TheBanner/>
    <div class="content-body">
        <div class="content-row">
            <h1>Deploy Your Own Art Based NRC-721 Contract</h1>
            <div class="row justify-content-center mb-5 mt-5">
            
                <div class="col-md-4 mt-2">
                    <div class="small mb-2">Only Costs Nebulas Gas Fees (<a href="https://github.com/rc108/nrc721-hybrid" target="_blank">contract source</a>)</div>
                    <input v-model="name" type="text" name="" placeholder="Name" class="form-control mb-1">
                    <input v-model="symbol" type="text" name="" placeholder="Symbol" class="form-control mb-1">
                    <input v-model="price" type="number" name="" placeholder="Sale Price" class="form-control mb-1">
                    <input v-model="supply" type="text" name="" placeholder="Supply" class="form-control mb-1">
                    <input v-model="license" type="text" name="" placeholder="License" class="form-control mb-1">
                    <input v-model="imageUrl" type="text" name="" placeholder="Image URL" class="form-control mb-1">
                    <input v-model="dnaLength" type="number" name="" placeholder="DNA Length 1 - 20" class="form-control">
                    <sub>Note: To and From Addresses must be the same when deploying new contracts.</sub>
                    <button v-if="!pendingTransaction" @click="deployContract" class="btn btn-lrg btn-primary mt-2">
                        Deploy Contract
                    </button>
                    <button v-else disabled class="btn btn-lrg btn-secondary">
                        Please wait ...
                    </button>
                </div>
                <div class="col-sm-12 col-md-3 offset-md-1 mt-1">
                    <div class="content-container">
                        <div class="content-display">
                            <i v-if="!imageUrl" class="fas fa-question"></i>
                            <img v-else :src="imageUrl" alt="" width="80%">
                        </div>
                        <div class="content-label">
                            {{ name || '...' }} ({{ symbol || '...' }})
                        </div>
                    </div>
                </div>

            </div>

            <h4 v-if="contract" class="mt-4">Your Contract Address</h4>
            <div v-if="contract" class="row justify-content-center mb-5 mt-3">
                <div class="col-md-4">
                    <input v-model="contract" type="text" disabled class="form-control text-center">
                </div>            
            </div>
        </div>


        <div class="content-row">
            <h1>Register On Our Platform</h1>
            <div class="row justify-content-center mb-1 pb-3">
            
                <div class="col-md-4">
                    <input v-model="name" type="text" name="" placeholder="Name" class="form-control mb-2">
                    <input v-model="symbol" type="text" name="" placeholder="Symbol" class="form-control mb-2">
                    <input v-model="description" type="text" name="" placeholder="Description" class="form-control mb-2">
                </div>
                <div class="col-md-4">
                    <input v-model="imageUrl" type="text" name="" placeholder="Image URL" class="form-control mb-2">
                    <input v-model="websiteUrl" type="text" name="" placeholder="Website Url" class="form-control mb-2">
                    <input v-model="userContract" type="text" name="" placeholder="Contract Address" class="form-control mb-2">
                </div>

            </div>
            <div class="row justify-content-center">

                <div class="col-md-10">
                    <button v-if="!pendingTransaction" @click="registerContract" class="btn btn-lrg btn-primary">
                        Register Token
                    </button>
                    <button v-else disabled class="btn btn-lrg btn-secondary">
                        Please wait ...
                    </button>
                </div>

            </div>
        </div>
        <div class="content-row">
            <h1>Browse All Contracts</h1>
            <div class="row justify-content-center text-center">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="content-container">
                        <div class="content-display">
                            <img src="/static/card_icy_hot.png" alt="card image" width="80%">
                        </div>
                        <div class="content-label">
                            Blue Origin
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="content-container">
                        <div class="content-display">
                            <img src="/static/card_bit_mac.png" alt="card image" width="80%">
                        </div>
                        <div class="content-label">
                            Bit Mac
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div class="content-container">
                        <div class="content-display">
                            <img src="/static/card_magic.png" alt="card image" width="80%">
                        </div>
                        <div class="content-label">
                            Magic
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mt-4">

                <div class="col-md-10">
                    <button @click="goToRoute('browse')" class="btn btn-lrg btn-primary">
                        Browse
                    </button>
                </div>

            </div>
        </div>


        <div class="shape one"></div>
        <div class="shape two"></div>
        <div class="shape large one"></div>
        <div class="shape large two"></div>
    </div>
</div>

</template>

<script>
import { mapGetters } from "vuex";
import Card from "../components/Card";
import TheBanner from "../components/layout/TheBanner";
import * as newCardLogic from "../util/newCardLogic";
import { contractAddress, nebPay, neb } from "../util/nebulas";

export default {
    name: "Home",
    computed: {
        ...mapGetters({
            cards: "getCards",
            users: "getUsers",
            contract: 'getContract',
            allCards: 'getAllCards',
            pendingTransaction: 'getPendingTransaction'
        })
    },
    created () {},
    data() {
        return {
            address: null,
            name: null,
            price: null,
            symbol: null,
            supply: null,
            license: null,
            imageUrl: null,
            dnaLength: null,

            description: null,
            websiteUrl: null,
            userContract: null,

            // Other
            dna: 0,
            level: 0,
        };
    },
    methods: {
        openModal (coinId) {
            $("#myModal").modal("show");
        },
        goToRoute (name) {
            this.$router.push(name);
        },

        deployContract () {
            const name = this.name;
            const price = this.price;
            const symbol = this.symbol;
            const supply = this.supply;
            const license = this.license;
            const imageUrl = this.imageUrl;
            const dnaLength = this.dnaLength; 

            if (!price || !name || !symbol || !supply || !license || !imageUrl || !dnaLength) {

                this.$notify({
                    group: 'app',
                    title: 'Warning!',
                    text: 'All fields are required!'
                });

                return;

            }

            this.$store.dispatch('deployContract', { 
                name, 
                price,
                symbol, 
                supply, 
                license, 
                imageUrl, 
                dnaLength
            }).then(response => {

                if (response.message == 'success') {

                    this.$notify({
                        group: 'app',
                        title: 'Success!',
                        text: 'You added a new transaction at' + response.contract + '!'
                    });

                    this.userContract = response.contract;

                } else {

                     this.$notify({
                        group: 'app',
                        title: 'Warning!',
                        text: 'There was a problem with your transaction!'
                    });

                }

            });

        },

        registerContract () {
            const name = this.name;
            const symbol = this.symbol;           
            const imageUrl = this.imageUrl;
            const contract = this.userContract;
            const websiteUrl = this.websiteUrl;
            const description = this.description;
            
            if (!name || !symbol || !imageUrl || !websiteUrl || !description || !contract) {

                this.$notify({
                    group: 'app',
                    title: 'Warning!',
                    text: 'All fields are required!'
                });

                return;

            }

            this.$store.dispatch('registerContract', { 
                name, 
                symbol, 
                description, 
                imageUrl, 
                websiteUrl,
                contract
            }).then(response => {
                
                if (response.message == 'success') {

                    this.$notify({
                        group: 'app',
                        title: 'Success!',
                        text: 'You have resgistered your token!'
                    });

                } else {

                     this.$notify({
                        group: 'app',
                        title: 'Warning!',
                        text: 'There was a problem with your transaction!'
                    });

                }

            });

        },

        // OTHER
        preloadImages () {},
        
        createLimitedEditionCard () {

            // Update pending status
            this.$store.commit('updatePendingTransaction', { status: true });

            this.$store.dispatch('createLimitedEditionCard', { dna: this.dna, level: this.level}).then((response) => {

                this.$store.commit('updatePendingTransaction', { status: false });

                if (response.message == 'error') {

                    this.$notify({
                        group: 'app',
                        title: 'Warning!',
                        text: 'There was a problem with your transaction!'
                    });

                } else {

                    this.$notify({
                        group: 'app',
                        title: 'Congrats!',
                        text: 'You have successfully purchased a new card!'
                    });

                }

            });

        },
        createCard () {

            // Start random loader
            let randomInterval = newCardLogic.startNewCardRandomizer(200, this);

            // Update pending status
            this.$store.commit('updatePendingTransaction', { status: true });

            this.$store.dispatch('createCard').then((response) => {

                this.$store.commit('updatePendingTransaction', { status: false });

                if (response.message == 'error') {

                    newCardLogic.resetNewCardRandomizer(randomInterval, this);

                } else {

                    newCardLogic.stopNewCardRandomizer(randomInterval, response.card, this);

                }

            });

        }
    },
    components: { TheBanner, Card }
    };
</script>

<style lang="less">
@import "../assets/less/app.less";

.content-container {
    cursor: default!important;
}

.home {
    .no-content {
        font-weight: bold;
        font-size: 24px;
        padding: 150px 0;
        text-align: center;
    }

    .content-body {
        position: relative;
        
        .fee {
            font-size: 13px;
            font-weight: bold;
        }
        .content-row {
            padding: 50px 0;
            text-align: center;
            

            h1 {
                margin: 20px 0 30px;
            }

            .versus {
                font-size: 32px;
                color: #000;
                position: relative;
                top: 40%;
            }


            .action-container {
                margin-top: 30px;
            }
        }

        .shape {
            width: 25%;
            position: absolute;
            opacity: 0.1;
            z-index: -1;

            &.one {
                height: 100%;
                left: 0;
                top: 0;
                background: #8E2DE2;
                -webkit-clip-path: polygon(0% 0%, 50% 100%, 0% 100%);
                clip-path: polygon(0% 0%, 40% 100%, 0% 100%);

                &.top {
                    -webkit-clip-path: polygon(0% 0%, 48% 0%, 0% 99%);
                    clip-path: polygon(0% 0%, 40% 0%, 0% 100%);
                }

                &.large {
                    -webkit-clip-path: polygon(0% 0%, 50% 100%, 0% 100%);
                    clip-path: polygon(0% 0%, 40% 0%, 0% 100%);
                }
            }

            &.two {
                height: 100%;
                right: 0;
                top: 0;
                background: #8E2DE2;
                -webkit-clip-path: polygon(1% 100%, 100% 1%, 99% 98%);
                clip-path: polygon(60% 100%, 100% 0%, 100% 100%);

                &.top {
                    -webkit-clip-path: polygon(100% 1%, 59% 0%, 100% 99%);
                    clip-path: polygon(100% 0%, 60% 0%, 100% 100%);
                }

                &.large {
                        -webkit-clip-path: polygon(1% 100%, 100% 1%, 99% 98%);
                    clip-path: polygon(60% 0%, 100% 0%, 100% 100%);
                }
            }
        }

    }
}

// Tablet device
@media only screen and (max-width: 768px) {
    body {
        .versus {
            margin: 30px 0;
            top: 0!important;
        }
    }
}

// Phone device
@media only screen and (max-width: 480px) {
     body {
        .shape {
            display: none!important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue